import { api } from '@/lib/api';

export interface ServiceDTO {
  id: string;
  userId: string;
  cnpjId: string;
  name: string;
  color: string;
  fixedShiftValue: number;
  tomadorCnpj: string | null;
  tomadorRazaoSocial: string | null;
  tomadorEmail: string | null;
  serviceCode: string | null;
  issRetained: boolean;
  issAliquot: number | null;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface ExamTypeDTO {
  id: string;
  serviceId: string;
  name: string;
  shortName: string;
  value: number;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface CnpjDTO {
  id: string;
  cnpj: string;
  legalName: string;
  isDefault: boolean;
}

export const servicesApi = {
  listCnpjs: () => api.get<CnpjDTO[]>('/cnpjs'),
  list: (cnpjId: string) => api.get<ServiceDTO[]>('/services', { cnpjId }),
  get: (id: string) => api.get<ServiceDTO>(`/services/${id}`),
  create: (payload: Record<string, unknown>) => api.post<ServiceDTO>('/services', payload),
  update: (id: string, payload: Record<string, unknown>) =>
    api.patch<ServiceDTO>(`/services/${id}`, payload),
  remove: (id: string) => api.delete<void>(`/services/${id}`),
  // Soft-delete não tem endpoint de "restore" explícito; o "Desfazer" recria
  // o serviço com o mesmo payload (fluxo aceito na v1.0, ver PRD §E2).
  restore: (payload: Record<string, unknown>) => api.post<ServiceDTO>('/services', payload),
  reorder: (id: string, newDisplayOrder: number) =>
    api.patch<ServiceDTO>(`/services/${id}/reorder`, { newDisplayOrder }),
};

export const examTypesApi = {
  list: (serviceId: string) =>
    api.get<ExamTypeDTO[]>(`/services/${serviceId}/exam-types`),
  create: (serviceId: string, payload: { name: string; shortName: string; value: number }) =>
    api.post<ExamTypeDTO>(`/services/${serviceId}/exam-types`, payload),
  update: (id: string, payload: Partial<{ name: string; shortName: string; value: number }>) =>
    api.patch<ExamTypeDTO>(`/exam-types/${id}`, payload),
  remove: (id: string) => api.delete<void>(`/exam-types/${id}`),
  reorder: (id: string, newDisplayOrder: number) =>
    api.patch<ExamTypeDTO>(`/exam-types/${id}/reorder`, { newDisplayOrder }),
};
